import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@material-ui/icons/ThumbDownOutlined";
import moment from "moment-timezone";
import Icon from "@material-ui/core/Icon";
import { getIconName } from "../../../utils/map";

const InfoWindowNews = (props) => {
  const { newsInfo, context, location } = props;
  const [seeMoreLabel, setSeeMoreLabel] = useState("More");
  const [icon, setIcon] = useState("image");
  const styles = useStyles();

  let label = "Potential Global Risk";
  if (newsInfo.affected === "N/A") {
    if (newsInfo.category.toUpperCase().startsWith("ESG")) label = "ESG Risk";
  }

  useEffect(() => {
    setIcon(getIconName(newsInfo.category));
  }, []);

  // const likeNews = async (newsInfo) => {
  //   context.setLoaderStatus(true);
  //   context.setInfoWindowIsShow(false);

  //   const data = {
  //     _id: newsInfo.item_id,
  //     feedback_status: "liked",
  //   };
  //   const { meta } = await sendFeedBack(data);

  //   if (!meta || meta.status !== 200) {
  //     alert(`Error ${meta ? meta.message : "Something went wrong"}`);
  //     context.setLoaderStatus(false);
  //     return;
  //   }

  //   context.setmessageToast({
  //     status: true,
  //     message: "Intelliegence upvoted",
  //     content: "We'll share more news similar to this.",
  //   });

  //   context.setLoaderStatus(false);
  // };

  // const disLikeNews = async (newsInfo) => {
  //   context.setLoaderStatus(true);
  //   context.setInfoWindowIsShow(false);

  //   const data = {
  //     _id: newsInfo.item_id,
  //     feedback_status: "disliked",
  //   };
  //   const { meta } = await sendFeedBack(data);

  //   if (!meta || meta.status !== 200) {
  //     alert(`Error ${meta ? meta.message : "Something went wrong"}`);
  //     context.setLoaderStatus(false);
  //     return;
  //   }

  //   context.setmessageToast({
  //     status: true,
  //     message: "Intelliegence downvoted",
  //     content: "We'll share fewer news similar to this.",
  //   });

  //   context.setLoaderStatus(false);
  // };

  // const sendFeedBack = async (dataPayload) => {
  //   const payLoad = {
  //     api_name: "intelligenceNewsFeedback",
  //     data: dataPayload,
  //   };
  //   const data = await intelligenceApiService.getIntelligenceData(payLoad);
  //   return data;
  // };

  const openMailBox = (newsInfo) => {
    window.open(
      `mailto:someone@gmail.com?subject=${newsInfo.email_subject}&body=${newsInfo.email_text}`,
      "_blank"
    );
    context.setInfoWindowIsShow(false);
  };

  const onClickSeeMore = () => {
    setSeeMoreLabel(seeMoreLabel === "More" ? "Less" : "More");
  };

  return (
    <React.Fragment>
      <Grid item xs={12} className={styles.infowWindow1}>
        <Card className={styles.root}>
          <CardContent className={styles.cardContent}>
            <Grid container>
              <Grid item xs={2}>
                <div className={styles.circle}>
                  <Icon>{icon}</Icon>
                </div>{" "}
              </Grid>
              <Grid
                item
                xs={10}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Typography className={styles.title} gutterBottom>
                  {newsInfo.news}
                </Typography>
              </Grid>
            </Grid>
            <Typography className={styles.pos} color="textSecondary">
              {newsInfo.source_name} | {newsInfo.category} |{" "}
              {moment.utc(newsInfo.event_timestamp).fromNow()}
            </Typography>
            {newsInfo.affected === "N/A" && (
              <Typography
                variant="body2"
                component="p"
                className={styles.content}
              >
                {label}
              </Typography>
            )}
            {newsInfo.affected !== "N/A" && newsInfo.port_affected === "N/A" && (
              <Typography
                variant="body2"
                component="p"
                className={styles.content}
              >
                <span>
                  {newsInfo.affected}{" "}
                  {newsInfo.affected > 1 ? "supplier(s)" : "supplier"}{" "}
                </span>{" "}
                in Tier {newsInfo.supplier_tier} at risk
              </Typography>
            )}
            {newsInfo.affected === "N/A" && newsInfo.port_affected !== "N/A" && (
              <Typography
                variant="body2"
                component="p"
                className={styles.content}
              >
                <span>
                  {newsInfo.port_affected}{" "}
                  {newsInfo.port_affected > 1 ? "port(s)" : "port"}{" "}
                </span>{" "}
                at risk
              </Typography>
            )}
            {newsInfo.affected !== "N/A" && newsInfo.port_affected !== "N/A" && (
              <Typography
                variant="body2"
                component="p"
                className={styles.content}
              >
                <span>
                  {newsInfo.affected}{" "}
                  {newsInfo.affected > 1 ? "supplier(s)" : "supplier"}{" "}
                </span>{" "}
                in Tier {newsInfo.supplier_tier} {"&"}{" "}
                <span>
                  {newsInfo.port_affected}{" "}
                  {newsInfo.port_affected > 1 ? "port(s)" : "port"}{" "}
                </span>
                at risk
              </Typography>
            )}
            <div style={{ padding: "5px 0px" }}>
              {newsInfo.suppliers.slice(0, 4).map((supplier) => {
                return (
                  <Typography
                    variant="caption"
                    display="block"
                    gutterBottom
                    key={supplier}
                    className={styles.supplier}
                  >
                    {supplier}
                  </Typography>
                );
              })}
              {newsInfo.ports.slice(0, 2).map((port) => {
                return (
                  <Typography
                    variant="caption"
                    display="block"
                    gutterBottom
                    key={port}
                    className={styles.supplier}
                  >
                    {port}
                  </Typography>
                );
              })}
              <Typography
                variant="caption"
                display="block"
                gutterBottom
                className={styles.supplier}
              >
                {newsInfo.suppliers.length > 4 ||
                  (newsInfo.ports.length > 2 && (
                    <Link href="#" color="inherit">
                      {`+ ${newsInfo.suppliers.slice(4).length + newsInfo.ports.slice(2).length} More...`}
                    </Link>
                  ))}
              </Typography>
            </div>
          </CardContent>
          <div style={{ marginBottom: "6px" }}>
            <CardActions className={styles.mailSection}>
              <div>
                <IconButton
                  aria-label="like"
                  className={styles.iconLike}
                  // onClick={(e) => {
                  //   likeNews(location);
                  // }}
                >
                  <ThumbUpOutlinedIcon fontSize="small" />
                </IconButton>
                <IconButton
                  aria-label="dislike"
                  className={styles.iconDisLike}
                  // onClick={(e) => {
                  //   disLikeNews(location);
                  // }}
                >
                  <ThumbDownOutlinedIcon fontSize="small" />
                </IconButton>
              </div>
              {/* <Button
                variant="contained"
                size="small"
                className={styles.btn}
                onClick={() => openMailBox(newsInfo)}
              >
                Send as email
              </Button> */}
            </CardActions>
          </div>
          <div className={styles.seeMore}>
            <Accordion style={{ boxShadow: "unset" }}>
              <AccordionSummary
                onClick={onClickSeeMore}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={styles.title}>
                  See {seeMoreLabel}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className={styles.contentSeeMore} component="p">
                  {newsInfo.summary}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </Card>
      </Grid>
    </React.Fragment>
  );
};
const useStyles = makeStyles(() => ({
  root: {
    borderRadius: "0px",
    width: 300,
    boxShadow: "none",
  },
  infowWindow1: {
    "& Button": {
      backgroundColor: "#363740",
      color: "#FFFFFF",
      fontSize: 12,
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "500",
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "#363740",
    },
    "& .MuiCardActions-root": {
      padding: "0px 8px 8px 0px",
      justifyContent: "start",
    },
    "& .MuiButton-root": {
      textTransform: "none",
    },
  },
  title: {
    fontSize: 12,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "bold",
    letterSpacing: "0.2px",
  },
  pos: {
    fontSize: 12,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "normal",
    letterSpacing: "0.2px",
  },
  content: {
    fontSize: 12,
    fontFamily: "Inter",
    letterSpacing: "0.2px",
    marginTop: 12,
    color: "#000000",
    "& span": {
      borderBottom: ".1px solid #000000",
    },
  },
  cardContent: {
    padding: "0px 0px 0px 0px",
  },
  iconLike: {
    color: "#000000 !important",
    marginRight: 10,
    borderRadius: "20%",
    background: "#A0FFC1 !important",
  },
  iconDisLike: {
    color: "#000000 !important",
    marginRight: 10,
    borderRadius: "20%",
    background: "#FF9A9A !important",
  },
  mailSection: {
    "& a": {
      backgroundColor: "#363740",
      color: "#FFFFFF",
      fontSize: 12,
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "500",
    },
    "& .MuiIconButton-root": {
      padding: "5px",
    },
  },
  supplier: {
    marginBottom: "0px",
    fontSize: 12,
    fontFamily: "Inter",
    letterSpacing: "0.2px",
    color: "#000000",
  },
  seeMore: {
    "& .MuiButtonBase-root": {
      padding: "0px",
    },
    "& .MuiIconButton-edgeEnd": {
      marginRight: "0px",
    },
    "& .MuiAccordionDetails-root": {
      padding: "0px",
    },
    "& .MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "30px",
      height: "25px",
    },
    "& .MuiAccordionSummary-root": {
      minHeight: "20px",
    },
    "& .MuiAccordionSummary-content": {
      margin: "0px",
    },
  },
  contentSeeMore: {
    fontSize: 12,
    fontFamily: "Inter",
    letterSpacing: "0.2px",
    color: "#000000",
  },
  circle: {
    backgroundColor: "#fff",
    border: "2px solid #4caf50",
    borderRadius: "50%",
    mozBorderRadius: "50%",
    webkitBorderRadius: "50%",
    padding: "4px",
    height: "35px",
    width: "35px",
  },
}));

export default InfoWindowNews;
